import { render, staticRenderFns } from "./RecommendFriendsWrapper.vue?vue&type=template&id=3b772725&scoped=true&"
import script from "./RecommendFriendsWrapper.vue?vue&type=script&lang=js&"
export * from "./RecommendFriendsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./RecommendFriendsWrapper.vue?vue&type=style&index=0&id=3b772725&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b772725",
  null
  
)

export default component.exports